import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/Home";
import ProductDetailPage from "./pages/ProductDetail";
import CheckoutPage from "./pages/Checkout";
import OrdersHistoryPage from "./pages/OrdersHistory";
import OrderDetailPage from "./pages/OrderDetail";
import ProfilePage from "./pages/Profile";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/:tenantId/products/:productId" element={<ProductDetailPage />} />
        <Route path="/:tenantId/checkout" element={<CheckoutPage />} />
        <Route path="/:tenantId/orders" element={<OrdersHistoryPage />} />
        <Route path="/:tenantId/orders/:orderId" element={<OrderDetailPage />} />
        <Route path="/:tenantId/profile" element={<ProfilePage />} />
        <Route path="/:tenantId" element={<HomePage />} />
        <Route path="/" element={<Navigate to="/default" replace />} />
        <Route path="*" element={<Navigate to="/default" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
